import { filter, find } from "lodash";
import ProfileAvatar from "PFComponents/profile_avatar/profile_avatar";
import EMOJIS from "PFComponents/text/emojis";
import InputFieldSet from "PFComponents/text/input_field_set";
import { gidFor } from "PFCore/helpers/gid";
import { getProfileName } from "PFCore/helpers/profile";
import { fetchMentionables } from "PFCore/services/chat/fetch_mentionables";
import PropTypes from "prop-types";
import React from "react";
import { startsWith } from "underscore.string";

class AutoCompleteInputFieldSet extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      openEmojisDropdown: this.props.openEmojisDropdown
    };

    this.props.saveRef && this.props.saveRef(this);
    this.mentions = {};
  }

  postReplace = (value) => {
    const sortedMentions = Object.keys(this.mentions).sort((keyA, keyB) => keyB.length - keyA.length);

    sortedMentions.forEach((key) => {
      const mention = this.mentions[key];
      const gid = gidFor("Profile", mention.id);
      const mentionDisplay = getProfileName(mention);

      value = value.split(`@${key}`).join(`@[${mentionDisplay}](${gid})`);
    });

    return value;
  };

  handleChange = (value) => {
    const { handleChange } = this.props;

    this.setState({ openEmojisDropdown: false });

    handleChange && handleChange(value, this.postReplace(value));
  };

  handleBlur = (event) => {
    const { handleBlur } = this.props;

    this.setState({ openEmojisDropdown: false });

    handleBlur && handleBlur(event);
  };

  render() {
    const { profileId, conversationId, displayEmojis, displayMentions } = this.props;
    const { openEmojisDropdown } = this.state;

    const autoCompleteReplace = [];
    const autoCompleteDropdowns = [];

    if (displayEmojis) {
      autoCompleteReplace.push({
        pattern: /:.*:?/g,
        replace: (matched) => {
          const emoji = find(EMOJIS, { pattern: matched });
          return emoji ? emoji.display : matched;
        }
      });

      autoCompleteDropdowns.push({
        trigger: /:[a-z]*$/,
        data: (value, cb) => {
          cb(
            filter(EMOJIS, (emoji) => startsWith(emoji.pattern, value)).map((emoji) => ({
              id: emoji.pattern,
              displayElement: <span>{`${emoji.display} ${emoji.pattern}`}</span>,
              item: () => emoji.display
            }))
          );
        }
      });
    }

    if (displayMentions) {
      autoCompleteDropdowns.push({
        trigger: /@\S* ?\S*$/,
        data: (value, cb) => {
          cb([
            {
              id: 0,
              displayElement: <span>...</span>,
              item: false
            }
          ]);
          fetchMentionables({ profileId, conversationId, term: value.replace("@", "") }).then(
            ({ entries: mentionables }) => {
              cb(
                mentionables.map((mention) => ({
                  id: mention.id,
                  displayElement: (
                    <React.Fragment>
                      <div style={{ display: "inline-block", verticalAlign: "middle" }}>
                        <ProfileAvatar profile={mention} size={16} />
                      </div>
                      {` ${getProfileName(mention)} `}
                      <small className="text-muted">{mention.email}</small>
                    </React.Fragment>
                  ),
                  item: () => {
                    let format = getProfileName(mention);

                    if (this.mentions[format] && this.mentions[format].id !== mention.id) {
                      format = `${format}[${mention.email}]`;
                    }

                    this.mentions[format] = mention;

                    return `@${format}`;
                  }
                }))
              );
            }
          );
        }
      });
    }

    return (
      <InputFieldSet
        {...this.props}
        autoCompleteReplace={autoCompleteReplace}
        autoCompleteDropdowns={autoCompleteDropdowns}
        openEmojisDropdown={openEmojisDropdown}
        handleChange={this.handleChange}
        handleBlur={this.handleBlur}
        inputType="textarea"
      />
    );
  }
}

AutoCompleteInputFieldSet.propTypes = {
  ...InputFieldSet.propTypes,

  displayEmojis: PropTypes.bool,
  displayMentions: PropTypes.bool,
  openEmojisDropdown: PropTypes.bool,
  profileId: PropTypes.number,
  conversationId: PropTypes.number,

  saveRef: PropTypes.func
};

AutoCompleteInputFieldSet.defaultProps = {
  ...InputFieldSet.defaultProps,

  displayEmojis: true,
  displayMentions: false,
  mentionables: null,
  openEmojisDropdown: false
};

export default AutoCompleteInputFieldSet;
